import { SignIn } from '@clerk/react-router'
import { getAuth } from '@clerk/react-router/server'
import { type SEOHandle } from '@nasa-gcn/remix-seo'
import { type LoaderFunctionArgs, redirect } from 'react-router'
import urls from '#app/data/urls.json'

export const handle: SEOHandle = {
	getSitemapEntries: () => null,
}

export async function loader(args: LoaderFunctionArgs) {
	const { userId } = await getAuth(args)
	if (userId) {
		return redirect('/')
	}
	return null
}

export default function SignInPage() {
	return (
		<div className="flex h-screen items-center justify-center">
			<SignIn
				appearance={{
					options: {
						privacyPageUrl: urls.privacyPageUrl,
						termsPageUrl: urls.termsPageUrl,
					},
					elements: {
						footerAction__signIn: {
							display: 'none',
						},
					},
				}}
			/>
		</div>
	)
}
